import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ExamManagementService } from '../../../../Services/exam-management/exam-management.service';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { NotificationAddEditComponent } from '../../../notification-management/notification-add-edit/notification-add-edit.component';

export interface IQuestion {
  Path_Name: any;
  Question_ID: string;
  Question_Text: any;
  Answer_Choices: AnswerChoice[];
  SelectedQuestion: boolean;
  ExtractQuestionsForMockExam: number;
  Number_Of_Answer_Choices: number;
  Total_Number_Of_Optional_Questions: number | null;
  Time_To_Answer_In_Seconds: number | null;
  Right_Answer_Default_Score: number | null;
  Wrong_Answer_Penalty_Default_Score: number | null;
  Optional_Question_Ind: boolean;
  TimeToAnswerInSeconds: number | null;
  RightAnswerDefaultScore: number | null;
  WrongAnswerPenaltyDefaultScore: number | null;
}

export interface AnswerChoice {
  Answer_Choice_Id: number
  Answer_Choice_Text: string
  Right_Answer_Ind: string
  All_Of_The_Above_Or_None_Of_The_Above_Ind: string
  Answer_Selected_IND: string
  selected: boolean
}

@Component({
  selector: 'app-weekly-practice-test-question-selection',
  templateUrl: './weekly-practice-test-question-selection.component.html',
  styleUrls: ['./weekly-practice-test-question-selection.component.css']
})
export class WeeklyPracticeTestQuestionSelectionComponent implements OnInit {
  private destroy$ = new Subject<void>();
  questions: IQuestion[] = [];
  weeklyPracticeTestId: number;
  courseId: number;
  practiceTestSequenceNumber: number;
  practiceTestName: string;
  ExamAgencyName: string;
  CourseName: string;
  ExamYear: string;
  subjectId: number;
  totalQuestions: number;
  subjectName: string;
  currentNumberOfQuestions: number = 0;
  questionId: string | null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ExamService: ExamManagementService,
    private readonly toaster: ToastrService,
    private location: Location,
    private modalServiceLocal: ModalService,
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    combineLatest([this.route.queryParams, this.route.params])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([queryParams, params]) => {
        this.courseId = +queryParams['c_id'];
        this.practiceTestSequenceNumber = +queryParams['p_Seq'];
        this.practiceTestName = queryParams['p_Name'] || '';
        this.ExamAgencyName = queryParams['eA_Name'];
        this.CourseName = queryParams['c_Name'];
        this.ExamYear = queryParams['eY_Name'];
        this.subjectId = +queryParams['s_id'];
        this.subjectName = queryParams['s_name'];
        this.questionId = queryParams['q_id'] ?? null;
        if (queryParams['t_q'] != null) {
          this.totalQuestions = +queryParams['t_q'];
        }
        this.weeklyPracticeTestId = +params['id'];
        this.getQuestionsForPracticeTest();
      });

      this.getPracticeTestQuestion();
  }

  getQuestionsForPracticeTest() {
    this.getPracticeTestQuestion();
    const request = {
      CourseTestId: this.weeklyPracticeTestId,
      CourseId: this.courseId,
      SubjectID: this.subjectId,
      NumberOfQuestions: this.totalQuestions??0,
      QuestionID: this.questionId,
    };
    this.ExamService.getQuestionForWeeklyPracticeTest$(request).subscribe((res) => {
      this.questions = res;
      console.log('🔥 Questions Response:', this.questions);
      // Initialize all answer checkboxes based on Selected_IND
      this.questions.forEach((question) => {
        console.log('🔥 Question:', question.Question_ID);
        question.Answer_Choices.forEach((choice) => {
          console.log('🔥 Answer Choice:', choice);
          console.log('🔥 Selected_IND value:', choice.Answer_Selected_IND, 'Type:', typeof choice.Answer_Selected_IND);
          choice.selected = choice.Answer_Selected_IND === 'Y' || choice.Answer_Selected_IND === 'Y' ;
          console.log('🔥 choice.selected set to:', choice.selected);
        });
      });
      if (this.questionId) {
        this.questions.forEach((question) => {
          question.SelectedQuestion = true;
        });
      }
    });
  }

  onQuestionSelectionChange(item: IQuestion, event: any): void {
    const checked = event.target.checked;
    if (checked) {
      this.currentNumberOfQuestions++;
    } else {
      this.currentNumberOfQuestions--;
    }
    if (!item.SelectedQuestion) {
      // Unselect all choices except for the correct answer
      item.Answer_Choices.forEach((choice: any) => {
        if (choice.Right_Answer_Ind !== 'Y') {
          choice.selected = false;
        }
      });
    } else {
      const numChoices = item.Answer_Choices.length;
      const numToSelect = item.Number_Of_Answer_Choices;
      if (numToSelect < numChoices) {
        this.toaster.warning(
          `You can only select ${numToSelect} of answers for this question`,
          'Warning',
          { timeOut: 1300 }
        );
      }

      if (numChoices < numToSelect) {
        this.toaster.warning(
          `You cannot select this question as only ${numChoices} answers are available for this question`,
          'Warning',
          { timeOut: 1300 }
        );
      }
      item.Answer_Choices.forEach((choice: any, idx: number) => {
        if (idx < item.Number_Of_Answer_Choices) {
          choice.selected = true;
        } else {
          choice.selected = false;
        }
      });
    }
  }

  getPracticeTestQuestion() {
    const payload = {
      CourseTestId: this.weeklyPracticeTestId,
      CourseTestStatusTypeCode: null,
    };
    this.ExamService.getWeeklyPracticeTestQuestion(payload).subscribe((res) => {
      res.find((subject: any) => {
        if (subject.Subject_Id === this.subjectId) {
          this.currentNumberOfQuestions = subject.Subject_Current_Number_Of_Question;
          this.totalQuestions = subject.Subject_Total_Number_Of_Question ?? this.totalQuestions;
          return true; // Breaks the loop
        }
        return false;
      });

    });
  }

  onAnswerSelectionChange(
    item: IQuestion,
    choice: AnswerChoice,
    event: Event
  ): void {
    const control = event.target as HTMLInputElement;
    const checked = control.checked;
    if (checked) {
      if (
        item.Answer_Choices &&
        item.Answer_Choices.filter((choice: any) => choice.selected).length <=
          item.Number_Of_Answer_Choices
      ) {
      } else {
        this.toaster.error(
          'You can not select more than ' +
            item.Number_Of_Answer_Choices +
            ' choices'
        );
        control.checked = false;
        choice.selected = false;
      }
    }
  }

  navigateBack() {
    this.location.back();
  }

  onSave() {
    if (this.questions) {
      const invalidQuestion = this.questions
        .filter((question) => question.SelectedQuestion)
        .find(
          (ques) =>
            ques.Answer_Choices.filter((e) => e.selected).length <
            ques.Number_Of_Answer_Choices
        );

      if (invalidQuestion) {
        this.toaster.error(
          `Please select total of ${invalidQuestion.Number_Of_Answer_Choices} Answer choices for question ${invalidQuestion.Question_ID}`,
          '',
          { timeOut: ConstantVars.ToastErrorTimeout }
        );
        return;
      }

      if (this.questions.some((question) => question.SelectedQuestion)) {
        const payload = {
          UDTTestQuestion: this.questions
            .filter((question) => question.SelectedQuestion)
            .map((question) => ({
              CourseTestId: this.weeklyPracticeTestId,
              QuestionId: question.Question_ID,
              QuestionNumber: 0,
              RightAnswerScore: question.RightAnswerDefaultScore ?? 0,
              WrongAnswerScore: question.WrongAnswerPenaltyDefaultScore ?? 0,
              TimeToAnswerInSeconds: question.TimeToAnswerInSeconds ?? 0,
              OptionalQuestionInd:
                question.Optional_Question_Ind === true ? 'Y' : 'N',
              SelectedIND: 'Y',
            })),

          UDTTestQuestionAnswerChoice: this.questions
            .filter((question) => question.SelectedQuestion)
            .reduce((acc, question) => {
              const choices = question.Answer_Choices.map((choice) => ({
                CourseTestId: this.weeklyPracticeTestId,
                QuestionId: question.Question_ID,
                AnswerChoiceId: choice.Answer_Choice_Id ?? 0,
                AnswerChoiceSequenceNumber: 0,
                SelectedIND: choice.selected ? 'Y' : 'N',
              }));
              return acc.concat(choices);
            }, [] as any[]),
        };

        this.ExamService.insertOrUpdateTestQuestion(payload).subscribe(
          (res) => {
            this.getPracticeTestQuestion();
            this.CreateNotification();
            this.toaster.success('Saved Successfully', 'Success', {
              timeOut: ConstantVars.ToastSucessTimeout,
            });
          },
          (error) => {
            console.log(error);
            this.toaster.error(error.error.Message, '', {
              timeOut: ConstantVars.ToastErrorTimeout,
            });
          }
        );
      }
    }
  }

  async CreateNotification(): Promise<boolean> {
    try {
      const result = await this.modalServiceLocal.open(
        'Confirmation',
        'Do you want to send notification to all the users about this Practice Test?',
        'Yes',
        'No'
      );

      if (!result) {
        return false;
      }

      const modalRef = this.modalService.open(NotificationAddEditComponent, {
        centered: true,
        size: 'xl',
        windowClass: 'custom-modal-width-notification-course',
        backdropClass: 'custom-backdrop-notification',
      });

      modalRef.componentInstance.screenName = 'PracticeTest';
      modalRef.componentInstance.MaterialId = this.weeklyPracticeTestId;

      const notificationResult = await modalRef.result
        .then((res: any) => res)
        .catch(() => false);

      return !!notificationResult;
    } catch (error) {
      console.error('CreateNotification dismissed or failed:', error);
      return false;
    }
  }

  setSelectedExamId(id: number | null) {
    this.ExamService.setSelectedExamId(id);
  }

  ngOnDestroy(): void {
    const currentUrl = this.router.url;

    const shouldKeepSelection =
      currentUrl.includes('Exam/WeeklyPracticeTests') ||
      currentUrl.includes('Exam/WeeklyPracticeTestsQuestion') ||
      currentUrl.includes('Exam/AddEditWeeklyPracticeTestQuestion');

    if (!shouldKeepSelection) {
      this.setSelectedExamId(null);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
